import { render } from "./GiftPoints.vue?vue&type=template&id=8fd97e3c"
import script from "./GiftPoints.vue?vue&type=script&lang=js"
export * from "./GiftPoints.vue?vue&type=script&lang=js"

import "./GiftPoints.vue?vue&type=style&index=0&id=8fd97e3c&lang=scss"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__